import { Divider, Flex, Modal, Typography } from 'antd'
import type { FC } from 'react'
import { memo } from 'react'

import { LinkRow } from './components/LinkRow'
import { PillList } from './components/PillList'
import { TicketDetail } from './components/TicketDetail'
import type { CardView, PillCategories } from './types'

const MODAL_WIDTH = 640

interface TicketModalProps {
  card: CardView
  categories: PillCategories
  onClose: () => void
  onCreateVersion?: (ticketId: string) => void
}

const RawTicketModal: FC<TicketModalProps> = ({
  card,
  categories,
  onClose,
  onCreateVersion,
}) => {
  const [, ...earlier] = card.tickets

  return (
    <Modal
      open
      title={card.title}
      onCancel={onClose}
      footer={null}
      width={MODAL_WIDTH}>
      <Flex vertical gap='small'>
        {card.subtitle && (
          <Typography.Text type='secondary'>{card.subtitle}</Typography.Text>
        )}
        <TicketDetail
          card={card}
          categories={categories}
          onCreateVersion={onCreateVersion}
        />
        {earlier.length > 0 && (
          <>
            <Divider titlePlacement='start' plain>
              Earlier versions ({earlier.length})
            </Divider>
            {earlier.map((ticket) => (
              <LinkRow key={ticket.id} link={ticket.link}>
                <Flex wrap gap='small' align='center'>
                  <Typography.Text>{ticket.title}</Typography.Text>
                  {ticket.subtitle && (
                    <Typography.Text type='secondary'>
                      {ticket.subtitle}
                    </Typography.Text>
                  )}
                  <PillList pills={ticket.pills} categories={categories} />
                </Flex>
              </LinkRow>
            ))}
          </>
        )}
      </Flex>
    </Modal>
  )
}

export const TicketModal = memo(RawTicketModal)
